import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import SubscriptionDTO from '../../DTOs/Subscription/SubscriptionDTO';
import MobileCard from './MobileCard';
import { USDollar } from '../../utilities/Constants';
import { formatPhoneNumber } from '../../utilities/PhoneFormat';

export default function SubscriptionCardMobile(props) {
    const { subscription, showDeleteSubscriptionDialog } = props;

    return (
        <MobileCard
            title={`Unit ${subscription.storageUnit.name}`}
            subtitle={`${subscription.appUser.firstName} ${subscription.appUser.lastName}`}
            status={subscription.inGoodStanding
                ? { label: 'Good standing', color: 'success' }
                : { label: 'Not in good standing', color: 'error' }}
            fields={[
                { label: 'Email', value: subscription.appUser.username },
                { label: 'Phone', value: formatPhoneNumber(subscription.appUser.phone) },
                { label: 'Door code', value: subscription.appUser.doorCode ?? null },
                { label: 'Licence', value: subscription.appUser.driversLicenseNumber },
                { label: 'Size', value: subscription.storageUnit.storageSize },
                { label: 'Price', value: USDollar.format(subscription.storageUnit.price) },
                { label: 'Payment', value: subscription.paymentOption.name },
            ]}
            actions={
                <Button variant={'outlined'} color={'error'} onClick={showDeleteSubscriptionDialog}>
                    Force Cancel Subscription
                </Button>
            }
        />
    );
}

SubscriptionCardMobile.propTypes = {
    subscription: PropTypes.objectOf(SubscriptionDTO).isRequired,
    showDeleteSubscriptionDialog: PropTypes.func.isRequired,
};
